import * as React from 'react'
import { useController } from 'react-hook-form'
import { iconTickS } from 'images'
import * as S from '../SellerVerification.styles'
import type { Path, FieldValues } from 'react-hook-form'

const CheckInput = <T extends FieldValues>({
  name,
  label,
  showError = true,
  children
}: React.PropsWithChildren<CheckInputProps<T>>) => {
  const { field, fieldState } = useController({
    name
  })

  if (!label && !children) return null

  return (
    <S.Input hasError={Boolean(fieldState.error)}>
      {(label || children) && (
        <S.FormLabel
          htmlFor={name}
          className="styled-label"
          data-testid={name}
          checked={field.value}
          checkbox
        >
          <span>{field.value && <img src={iconTickS} alt="checked" />}</span>
          {children || label}
          <input id={name} type="checkbox" {...field} />
        </S.FormLabel>
      )}

      {fieldState.error && showError && (
        <S.FormHint error>{fieldState.error.message}</S.FormHint>
      )}
    </S.Input>
  )
}

export default CheckInput

interface CheckInputProps<T extends FieldValues> {
  name: Path<T>
  label?: string
  showError?: boolean
}
